var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { domainService } from '~/config/server';
import { NetService } from '~/utils/net.service';
import { Inject } from "~/core/decorator";
import { FilterService } from '~/utils/filter.service';
var ReportManageService = /** @class */ (function () {
    function ReportManageService() {
    }
    /**
     * 回款统计查询
     */
    ReportManageService.prototype.getAllRepaymentReportData = function (data) {
        return this.netService.send({
            server: domainService.reportController.getAllRepaymentReportData,
            data: data
        });
    };
    /**
     * 每日催收统计
     */
    ReportManageService.prototype.queryCollectDataDays = function (data) {
        var params = __assign({}, data);
        params.queryDateMin = FilterService.dateRanageFormat(data.queryDate).start;
        params.queryDateMax = FilterService.dateRanageFormat(data.queryDate).end;
        delete params.queryDate;
        return this.netService.send({
            server: domainService.reportController.queryCollectDataDays,
            data: params
        });
    };
    __decorate([
        Inject(NetService)
    ], ReportManageService.prototype, "netService", void 0);
    return ReportManageService;
}());
export { ReportManageService };
